export default __webpack_public_path__ + "static/media/target_icon.125437ce.png";